<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <app-filter-item>
            <gj-select-input
                v-model="filter.code"
                :options="option.code"
                :width="['100px', '150px']"
            ></gj-select-input>
          </app-filter-item>
          <app-filter-item>
            <gj-supplier-select
                v-model="filter.supplierCode"
                placeholder="供应商"
            ></gj-supplier-select>
          </app-filter-item>
          <app-filter-item>
            <gj-warehouse-select
                v-model="filter.warehouseId"
                :fba="false"
                placeholder="采购仓"
            ></gj-warehouse-select>
          </app-filter-item>
          <app-filter-item>
            <gj-select-input
                v-model="filter.keyword"
                :options="option.keyword"
                :width="['100px', '150px']"
            ></gj-select-input>
          </app-filter-item>
          <app-filter-item priority="2">
            <gj-creator-select
                v-model="filter.creator"
            ></gj-creator-select>
          </app-filter-item>
          <app-filter-item priority="1">
            <gj-select-date-picker
                v-model="filter.date"
                :options="option.date"
                type="daterange"
                :width="['120px']"
            ></gj-select-date-picker>
          </app-filter-item>
          <template #right>
            <gj-tool-group
                :download="$permission('purchaseDeliveryNote:export')" download-url="/supply/purchaseDeliveryNote/export" :download-params="globalParams"
                help
            ></gj-tool-group>
            <view-setting
                    :ref="REF_VIEW_SETTING"
                    save-mode="remote"
                    :use-default="true"
                    :module-name="moduleName"
                    :config="model"
                    :fn-generate-params="generateViewParams"
                    @view-change="handleChangeView"
                    @view-complete="handCompleteView"
            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :name="tableName"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :show-overflow="false"
            :scroll-x="{gt: -1}"
            :scroll-y="{gt: -1}"
            :extend-row-config="{prop: 'extendRow'}"
            :structure-config="{type: 'ParentChild', children: 'products', parentSpan: [0, 9]}"
            sortable="custom"
            :pagination="pagination"
            :default-sort="{prop: 'createTime', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <template v-slot:code="{row}">
            <template v-if="row.$gjParentData">
              <div style="display: inline-block; width: 150px;">
                {{row.code | defaultShow}}
                <gj-copy-icon :content="row.code"/>
              </div>
              <div v-gutter="20" style="display: inline-block;">
                <span>{{row.deliveryWarehouseName | defaultShow}}</span>
                <gj-tag
                    type="plain"
                    shape="rectangle"
                    :color="row.status | optionColor(DeliveryOrderEnum.statusOption)">
                  {{ row.status | optionText(DeliveryOrderEnum.statusOption) }}
                </gj-tag>
                <gj-text max-width="200px">{{row.supplierName | defaultShow}}</gj-text>
                <gj-tag
                    type="dark"
                    shape="rectangle"
                    :color="row.settlementWay | optionColor(DeliveryOrderEnum.settleOption)">
                  {{ row.settlementWay | optionText(DeliveryOrderEnum.settleOption) }}
                </gj-tag>
                <span><span class="parent-table-label">总金额：</span>{{row.totalAmount | amount | defaultShow(row.currencySymbol)}}</span>
                <span><span class="parent-table-label">总费用：</span>{{row.totalFee | amount | defaultShow(row.feeCurrencySymbol)}}</span>
                <span><span class="parent-table-label">创建人：</span>{{row.createUserName | defaultShow}}</span>
                <span><span class="parent-table-label">创建时间：</span>{{row.createTime | defaultShow}}</span>
                <span><span class="parent-table-label">交货量/入库量：</span>{{row.totalAlreadyDeliveryQuantity || 0}} / {{row.totalInboundQuantity || 0}}</span>
                <span><span class="parent-table-label">备注：</span><gj-text max-width="200px">{{row.memo | defaultShow}}</gj-text></span>
              </div>
            </template>
            <template v-else>
              {{row.purchaseOrderCode | defaultShow}}
              <gj-copy-icon :content="row.purchaseOrderCode"/>
            </template>
          </template>
          <template v-slot:sku="{row}">
            <div>
              <gj-text>{{row.productName | defaultShow}}</gj-text>
            </div>
            <div>{{row.sku | defaultShow}}</div>
            <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
          </template>
          <template v-slot:realDeliveryDate="{row}">
            <gj-edit-input
                v-if="$permission('purchaseDeliveryNote:add')"
                :value="row.actualDeliveryDate"
                :item="row"
                type="date"
                table-cell-edit
                width="100%"
                :pop-title="'实际交货日期'"
                :on-confirm="updateRealDeliveryDate">
              {{row.actualDeliveryDate | defaultShow}}
            </gj-edit-input>
            <template v-else>{{row.actualDeliveryDate | defaultShow}}</template>
          </template>
          <template v-slot:op="{row}">
            <template v-if="row.$gjParentData">
              <gj-button-group
                  type="dropdown-op"
                  :config="opBtnConfig(row)"
              ></gj-button-group>
            </template>
          </template>
          <template v-slot:extend:row="{row}">
            <div class="default">
              <div v-if="!row.expand">
                <gj-link type="default" @click="openDetail(row,true)">
                  更多（共{{row.num}}条）
                  <i class="iconfont iconzhankai"></i>
                </gj-link>
              </div>
              <div v-else>
                <gj-link type="default" @click="openDetail(row, false)">
                  收起
                  <i class="iconfont iconshouqi"></i>
                </gj-link>
              </div>
            </div>
          </template>
        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
  import {queryMixin, responseMixin, selectionMixin, valueCheckMixin} from "@/minxins";
  import {DeliveryOrderEnum} from "./enum";
  import AppDeliveryOrderDetailModal from "./modal/op-delivery-order-modal";
  import AppFilterItem from "../../../layout/components/module/app-filter-item";
  import {
    cancelDeliveryOrder,
    getDeliveryOrderPage,
    updateDeliveryOrderActualDeliveryDate
  } from "@/api/purchase";
  import {defaultVal} from "@/utils/common";
  import {OpEnum, ProductEnum} from "@/utils/options";
  import {convertToDate, generateViewParams} from "@/utils/date.util";
  import viewConfig from './viewConfig'

  export default {
    name: "app-delivery-order",
    components: {AppFilterItem},
    mixins: [queryMixin, selectionMixin, responseMixin, valueCheckMixin],
    data() {
      return {
        tableName: 'deliveryOrder',
        tableData: [],
        columns: [
          {id: 'code', header: '采购单号', field: 'slot:code', minWidth: '180px'},
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '50px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '300px'},
          {id: 'deliveryQuantity', header: '交货量', field: 'deliveryQuantity', defaultShow: 0, width: '80px', align: 'right'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', prefix: 'currencySymbol', width: '120px', align: 'right'},
          {id: 'amount', header: '金额', field: 'amount', prefix: 'currencySymbol', width: '120px', align: 'right'},
          {id: 'memo', header: '备注', field: 'memo', minWidth: '200px'},
          {id: 'inboundQuantity', header: '入库量', field: 'inboundQuantity', width: '80px', align: 'right'},
          {id: 'expectDeliveryDate', header: '预计交货日期', field: 'expectDeliveryDate', width: '150px'},
          {id: 'realDeliveryDate', header: '实际交货日期', field: 'slot:realDeliveryDate', width: '150px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right'}
        ],
        opBtnConfig: (row) => [
          {
            label: '详情',
            click: () => this.view({...row, products: row.productsCopy})
          },
          {
            label: '编辑',
            show: () => this.$permission('purchaseDeliveryNote:add')
              && (row.status === DeliveryOrderEnum.status.waitInbound || row.status === DeliveryOrderEnum.status.inInbound),
            click: () => this.edit({...row, products: row.productsCopy})
          },
          {
            label: '作废',
            show: () => this.$permission('purchaseDeliveryNote:abolish')
              && row.status === DeliveryOrderEnum.status.waitInbound,
            click: () => this.cancel([{...row, products: row.productsCopy}])
          },
          {
            label: '日志',
            click: () => this.viewLog({...row, products: row.productsCopy})
          },
        ],
        filter: {
          code: {
            key: 'code',
            value: null,
          },
          countryMarket: null,
          supplierCode: null,
          warehouseId: null,
          keyword: {
            key: 'sku',
            value: null
          },
          creator: null,
          date: {
            key: 'CreateTime',
            value: null
          }
        },
        option: {
          code: [
            {id: 'code', text: '交货单号'},
            {id: 'purchaseOrderCode', text: '采购单号'}
          ],
          keyword: [
            {id: 'sku', text: 'SKU'},
            {id: 'productName', text: '产品名称'},
          ],
          date: [
            {id: 'CreateTime', text: '创建时间'},
            {id: 'ExpectDeliveryDate', text: '预计交货日期'},
            {id: 'ActualDeliveryDate', text: '实际交货日期'},
          ]
        },
        DeliveryOrderEnum: DeliveryOrderEnum,
        productTypeOption: ProductEnum.typeOption,
        model: viewConfig,
        moduleName: 'DELIVERY_ORDER',
        tableList: []
      }
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date
                ? params.date
                :
                {
                  key: params.dateType,
                  value: [params.startDateTime, params.endDateTime]
                }

        this.filter = Object.assign({}, this.filter, {
          ...params,
          date
        })
      },
      $gjQueryInitParams() {
        return {
          filter: {
            code: {
              key: 'code',
              value: null,
            },
            countryMarket: null,
            supplierCode: null,
            warehouseId: null,
            keyword: {
              key: 'sku',
              value: null
            },
            creator: null,
            date: {
              key: 'CreateTime',
              value: null
            }
          },
        };
      },
      $gjQuery() {
        const date = this.filter.date.value;
        // 构造查询参数
        const params = {
          model: {
            [this.filter.code.key]: this.filter.code.value,
            supplierCode: this.filter.supplierCode,
            deliveryWarehouseId: defaultVal(this.filter.warehouseId),
            [this.filter.keyword.key]: this.filter.keyword.value,
            createUserId: this.filter.creator,
            [`start${this.filter.date.key}`]: date ? convertToDate(date[0]) : null,
            [`end${this.filter.date.key}`]: date ? convertToDate(date[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getDeliveryOrderPage(params)
          .then((data) => {
            this.tableData = data.records.map((v, i) => {
              const products = this._.cloneDeep(v.products || [])
              return Object.assign(v, {
                productsCopy: products,
                products: products.slice(0, 3),
                expand: false,
                dataIndex: i
              })
            });
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
      },
      updateRealDeliveryDate(value, row, closeEditor, closeLoading) {
        updateDeliveryOrderActualDeliveryDate({
          id: row.id,
          actualDeliveryDate: convertToDate(value),
        })
          .then(res => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('修改成功');
              this.$gjResetPage();
              closeEditor();
            });
          })
          .complete(() => closeLoading());
      },
      view(item) {
        this.$gjCreate(AppDeliveryOrderDetailModal, {
          props: {
            deliveryOrder: item,
            opType: OpEnum.type.VIEW
          }
        });
      },
      edit(item) {
        this.$gjCreate(AppDeliveryOrderDetailModal, {
          props: {
            deliveryOrder: item,
            opType: OpEnum.type.UPDATE
          },
          on: {
            updated: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      cancel(rows) {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: rows.length > 1 ? '作废' : `作废<span class="modal-secondary-title">${rows[0].code}</span>`,
            label: '作废理由',
            labelWidth: '75px',
            contentStyle: {padding: '16px 20px 20px 20px'},
            notMargin: true
          },
          on: {
            submit: (reason) => {
              modal.confirmLoading = true;
              cancelDeliveryOrder({
                id: rows[0].id,
                memo: reason
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('作废成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        })
      },
      viewLog(row) {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: `/supply/purchaseDeliveryNote/log/page`,
            params: {
              model: row.id
            },
            columns: DeliveryOrderEnum.logColumns
          }
        });
      },
      openDetail(row, flag){
        if (flag) {
          row.products = row.productsCopy;
          row.expand = flag;
        } else {
          row.products = row.products.slice(0,3);
          row.expand = flag;
        }
        this.tableData = this.tableData.map(v => {
          if (v.id === row.id) {
            v.expand = row.expand
            v.products = row.products
          }
          return v
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.iconfont{
  font-size: 10px;
  color: #999;
}
.iconshouqi{
  margin-left: 5px;
}
.default {
  /deep/ .gj-link{
    &:hover{
      .iconfont{
        color: #1F6EEF;
      }
    }
  }
}
</style>
